import { Building2, CreditCard, LayoutDashboard, Receipt, Tags, Users, type LucideIcon } from 'lucide-react'

export const nav: { to: string; label: string; icon: LucideIcon; end?: boolean }[] = [
  { to: '/', label: 'Overview', icon: LayoutDashboard, end: true },
  { to: '/teams', label: 'Teams', icon: Building2 },
  { to: '/users', label: 'Users', icon: Users },
  { to: '/subscriptions', label: 'Subscriptions', icon: CreditCard },
  { to: '/invoices', label: 'Invoices', icon: Receipt },
  { to: '/plans', label: 'Plans', icon: Tags },
]
